import {useState} from 'react';

import {CardWidgetBanner} from 'shells/card/card-widget-banner/card-widget-banner';
import {CompanySearchRegularAiIcon} from 'shells/icon';
import {Body} from 'shells/typography/body';

import type {
    EnrichmentResponse,
    GetAccountEnrichment_accountEnrichment as AccountEnrichmentField,
} from 'nutshell-graphql-types';

import {useAccountEnrichmentRespond} from '../../../../nutshell-intelligence-enrichment/company-enrichment/graphql/hooks';
import {
    ReviewEnrichmentDataModal,
    type EnrichmentResponseStatus,
} from '../../../../nutshell-intelligence-enrichment/review-enrichment-data-modal/review-enrichment-data-modal';

import {accountRefetchForEvent} from '../../hooks/use-account-update-refetch';

interface Props {
    accountId: string;
    companyName: string | null | undefined;
    accountEnrichment: AccountEnrichmentField[];
    onDismiss: () => void;
}

export function AccountCompanyIqBanner(props: Props) {
    const [isShowingModal, setIsShowingModal] = useState<boolean>(false);
    const [actionStatus, setActionStatus] = useState<EnrichmentResponseStatus | null | undefined>(
        undefined
    );

    const {accountEnrichmentRespond, error, loading} = useAccountEnrichmentRespond(props.accountId);

    const entityName = props.companyName ?? 'this company';

    const onAccountEnrichmentRespond = (response: EnrichmentResponse) => {
        setActionStatus(response);
        accountEnrichmentRespond(response)
            .then(() => {
                props.onDismiss();
                setIsShowingModal(false);
                if (response === 'ACCEPTED') {
                    accountRefetchForEvent('accountEnrichmentUpdated');
                }
            })
            .catch(() => {
                setActionStatus('ERROR');
            });
    };

    return (
        <>
            <CardWidgetBanner
                key='peep-company-enrichment'
                title='Company IQ'
                secondaryTitle={
                    <>
                        Additional information found about{' '}
                        <Body isBold={true} size='small'>
                            {entityName || 'this company'}
                        </Body>
                        .
                    </>
                }
                titleIcon={CompanySearchRegularAiIcon}
                actionLabel='Review'
                onClick={() => setIsShowingModal(true)}
                onDismiss={props.onDismiss}
                widgetType='NUTSHELL_IQ'
            />
            {isShowingModal && (
                <ReviewEnrichmentDataModal
                    entityName={props.companyName}
                    onClose={() => setIsShowingModal(false)}
                    data={props.accountEnrichment}
                    additionalFields={{
                        socialFields: null,
                        companyFields: null,
                    }}
                    onSave={() => {
                        onAccountEnrichmentRespond('ACCEPTED');
                    }}
                    onDecline={() => {
                        onAccountEnrichmentRespond('DECLINED');
                    }}
                    error={error}
                    loading={loading}
                    actionStatus={actionStatus}
                    setActionStatus={setActionStatus}
                />
            )}
        </>
    );
}
